import {Normalizer} from "../types";

// 'postaceki' alanı normalizer'ı.
//
// Kaynak: uyap/BorcluPostaCeki.ts — BorcluPostaCekiCevap = ISorguSonuc<Array<IPostaCekiSonuc>>.
// parse() (BorcluPostaCeki.ts:54-57) diziye HİÇ dokunmuyor, yalnızca data.message set
// ediyor; yani buradaki cevap.sorguSonucDVO ham UYAP şekliyle birebir aynı.
//
// sorguSonucu:false / kayıt-yok dalında sorguSonucDVO'nun dizi mi yoksa undefined mi
// kalacağı bu dosyada gözlenmedi (tek mock, alternatif yok) — bu yüzden Array.isArray
// ile savunmacı okunuyor (icradosyakaydi/bankahesap alanlarındaki gözlenmiş desenle tutarlı).
//
// KRİTİK ALAN ADI NOTU: IPostaCekiSonuc arayüzü "hesapSubeAdi" tanımlıyor ama gerçek
// UYAP mock verisi "hesapSubeAd" alanını taşıyor (interface eski/hatalı). Gerçek çalışma
// zamanı yolu (hesapSubeAd) önceliklidir; interface'teki isim de yedek olarak denenir.
export const postacekiNormalizer: Normalizer = (cevap) => {
    const liste = cevap?.sorguSonucDVO;
    if (!Array.isArray(liste)) {
        return {entities: []};
    }

    const entities = liste.map((sonuc: any) => {
        const kimlikNo = sonuc?.kimlikNo ?? sonuc?.vergiNo;
        const key = kimlikNo === undefined || kimlikNo === null ? "" : String(kimlikNo);

        const adSoyad = [sonuc?.ad, sonuc?.soyad]
            .filter((parca) => typeof parca === "string" && parca.trim() !== "")
            .join(" ")
            .trim();
        const label = adSoyad || key;

        const attrs: Record<string, unknown> = {};
        if (sonuc?.hesapBakiye !== undefined) attrs.hesapBakiye = sonuc.hesapBakiye;
        if (sonuc?.hacizTutar !== undefined) attrs.hacizTutar = sonuc.hacizTutar;
        if (sonuc?.hacizKoyan !== undefined) attrs.hacizKoyan = sonuc.hacizKoyan;

        const hesapSubeAdi = sonuc?.hesapSubeAd ?? sonuc?.hesapSubeAdi;
        if (hesapSubeAdi !== undefined) attrs.hesapSubeAdi = hesapSubeAdi;

        return {key, label, attrs};
    });

    const toplamBakiye = entities.reduce((toplam: number, e) => {
        const bakiye = e.attrs.hesapBakiye;
        return toplam + (typeof bakiye === "number" ? bakiye : 0);
    }, 0);

    return {
        entities,
        ozet: {
            hesapSayisi: entities.length,
            toplamBakiye
        }
    };
};
